import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';
import SEO, { SEO_CONFIG } from '../components/SEO';
import Navbar from '../features/splash/Navbar';
import PricingCards from '../features/splash/PricingCards';
import '../styles/splash.css';

const PricingPage = () => {
    const { user, ready } = useAuth();

    // Scroll to top on mount
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    // Wait for auth to resolve before deciding
    if (!ready) {
        return null;
    }

    // Redirect logged-in users to dashboard
    if (user) {
        return <Navigate to="/dashboard" replace />;
    }

    return (
        <div className="splash-page-root splash-pricing-page">
            <SEO {...SEO_CONFIG.pricing} />
            <Navbar />
            <PricingCards isStandalone />
        </div>
    );
};

export default PricingPage;
